import { create } from 'zustand/index';
import { persist } from 'zustand/middleware';

export type Filters = Partial<{
  equipmentCode: string
  containerCode: string
  companyId: string[];
}>

export type PaginationControl = {
  page: number;
  limit: number;
  orderBy?: string;
  orderByDirection?: 'asc' | 'desc';
};

type State = {
  filters: Filters;
  paginationControl: PaginationControl;
};

type Actions = {
  updateFilters: (filters: Filters) => void;
  updatePaginationControl: (
    paginationControl: Partial<PaginationControl>,
  ) => void;
  clearState: () => void;
};

type Options = {
  persisted?: boolean;
};

const getInitialState = (): State => ({
  filters: {},
  paginationControl: {
    page: 1,
    limit: 10,
  },
});

const PERSISTENCE_OPTIONS = {
  name: 'equipments-search-params',
  version: 1,
};

export const useEquipmentSearchParams = create(
  persist<State & Actions>(
    (set, get) => ({
      ...getInitialState(),
      updateFilters: (filters) => {
        const paginationControl = get().paginationControl;

        set({
          filters,
          paginationControl: { ...paginationControl, page: 1 },
        });
      },
      updatePaginationControl: (newState) => {
        const currentState = get().paginationControl;
        if (newState?.orderBy) {
          newState.page = 1;
        }

        return set((state) => ({
          paginationControl: {
            ...currentState,
            ...newState,
          },
        }));
      },
      clearState: () => set(getInitialState()),
    }),
    PERSISTENCE_OPTIONS,
  ),
);
